import { P2GBox, P2GGrid, SvgClose } from '@parcel2go/core-ui';
import ActionIcon from './ActionIcon';

interface StdBarProps {
  closeText: string;
  cancel?: () => void;
  isXs: boolean;
  children: React.ReactNode;
}

const StdBar: React.FC<StdBarProps> = (props) => {
  const p = props.isXs ? 1 : 2;
  return (
    <P2GGrid container alignItems="center" wrap="nowrap" classNames={'p2g-action-bar'} justify="center" gap={3}>
      {props.children}
      {props.cancel && (
        <P2GGrid item flexShrink={1}>
          <div style={{ borderLeft: '1px solid #dddddd' }} onClick={props.cancel}>
            <P2GBox p={p}>
              <ActionIcon icon={<SvgClose />} text={props.closeText} />
            </P2GBox>
          </div>
        </P2GGrid>
      )}
    </P2GGrid>
  );
};

export default StdBar;
